import { createStyles, makeStyles } from "@material-ui/core";
import { baseColors, RelodeTheme, Text } from "@relode/core";
import * as React from "react";

const useHeaderTitleStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            title: {
                [theme.breakpoints.down("sm")]: {
                    fontSize: "28px",
                    lineHeight: "35px",
                },
            },
            subTitle: {
                color: baseColors.gray,
                [theme.breakpoints.down("sm")]: {
                    fontSize: "14px",
                    lineHeight: "24px",
                },
            },
        }),
    { name: "desktopHeader" }
);

export const PageHeaderTitle = (props: { title: string; subTitle: string }) => {
    const classes = useHeaderTitleStyles({});
    return (
        <div className={classes.root}>
            <Text
                variant="h1"
                className={classes.title}
                dataCy="page-header-title-text"
            >
                {props.title}
            </Text>
            {!!props.subTitle ? (
                <Text variant="body1" className={classes.subTitle}>
                    {props.subTitle}
                </Text>
            ) : null}
        </div>
    );
};
